import axios from 'axios'
import { Message, Loading } from 'element-ui'
import router from '../router'
import store from '../store/index'

const loading = Loading.service
let loadingObj = null

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API
})

// request 拦截
service.interceptors.request.use(config => {
    // do something
    if (!config.noLoading) {
        loadingObj = loading({
            fullscreen: true
        })
    }
    config.headers['langvalue'] = 1
    config.headers['currencyarea'] = store.state.user.currencyarea
    const locale = localStorage.getItem('locale')
    switch (locale) {
        case 'zh':
            config.headers['langvalue'] = 1
            break
        case 'zh_HK':
            config.headers['langvalue'] = 2
            break
        default:
            config.headers['langvalue'] = 1
            break
    }
    const token = localStorage.getItem('token')
    if (token) {
        config.headers['Authorization'] = `${token}`
    }
    return config
}, err => {
    return Promise.reject(err)
})

// response 拦截
service.interceptors.response.use(response => {
    let res = response.data
    if (!response.config.noLoading) {
        loadingObj.close()
    }
    if (res.code < 0) {
        Message.error(res.msg)
        return Promise.reject(res)
    }
    if (res.code === 401) {
        store.dispatch('logout')
        router.push('/login')
        return Promise.reject(res)
    }
    if (res.code === 502) {
        store.dispatch('logout')
        router.push('/login')
        return Promise.reject(res)
    }
    return res
}, err => {
    loadingObj.close()
    Message.error(err.message)
    return Promise.reject(err)
})

export default service